import { Injectable } from '@angular/core';
import {CommonService} from './common.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LoadingOrdersService {

  constructor(private commonService: CommonService,
              private httpClient: HttpClient) { }


  public checkSerialNumber(body: any): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.post(`loading_command/web/can_put_serial`, body).subscribe((result) => {
        resolve(result);
      });
    });
  }

  public updateSerialNumber(body: any): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.put(`loading_command/web/serial_number`, body).subscribe((result) => {
        resolve(result);
      });
    });
  }
}
